<template lang="pug">
center 
 div(style="width: 100%;font-weight: bold;font-size: 28px;" class="ht-section-title") 會員資料
 .userInfo
  div(style="width:100%")
      i(class="el-icon-setting userInfo-icon" style="font-size: 23px;" @click="outerVisible = true")
  div(style="display: flex;height: 70px;line-height: 70px;") 
      div(style="padding-left:10px;width:35%") 會員姓名
      el-input(v-model="User.userName" style="width:45%"  :disabled="true")
      div(style="width:15%")
  div(style="display: flex;height: 70px;line-height: 70px;") 
      div(style="padding-left:10px;width:35%") 會員等級
      el-input(v-model="User.lvName" style="width:45%" :disabled="true")
      div(style="width:15%")
  div(style="display: flex;height: 70px;line-height: 70px;") 
      div(style="padding-left:10px;width:35%") 儲值金餘額
      el-input(v-model="User.prepaid" style="width:45%" :disabled="true")
      div(style="width:15%")
      // el-button(@click="outerVisible = false") 儲值金說明
  p
  p
  a(class="add-button ht-header-bttn ht-mobile-hide" size="mini" type="primary" @click="add_to_home()") 新增至主畫面
  p
  p
  div(v-show="show_go_to_line" style="margin-top: 50px;" onclick='window.open("https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1655423076&redirect_uri=https%3A%2F%2Fserver.ezwash.com.tw%2Fline%2Flogin%2Fcallback&state=1234511111678abcde&scope=profile%20openid&nonce=109876xyz&bot_prompt=aggressive");')
    el-button(type="success" style="background-color:rgb(1 185 5);width: 200px;") 開啟Line通知
  
 
  
 el-dialog(title="會員資訊" :visible.sync="outerVisible" width="80%")
    el-dialog(
      width="80%"
      title="會員儲值金"
      :visible.sync="innerVisible"
      append-to-body)
      center 如您想使用儲值扣款功能，請洽詢Line@官方帳號。專員會儘速與您聯繫說明儲值及扣款方式。
    div(style="display: flex;height: 70px;line-height: 70px;") 
        div(style="padding-left:10px;width:35%") 會員姓名
        el-input(v-model="User.userName" style="width:45%"  :disabled="false")
        div(style="width:15%")
    div(style="display: flex;height: 70px;line-height: 70px;") 
        div(style="padding-left:10px;width:35%") 會員等級
        el-input(v-model="User.lvName" style="width:45%" :disabled="true")
        div(style="width:15%")
    div(style="display: flex;height: 70px;line-height: 70px;") 
        div(style="padding-left:10px;width:35%") 儲值金餘額
        el-input(v-model="User.prepaid" style="width:45%" :disabled="true")
        div(style="width:10%;")
            el-button(type="primary" @click="innerVisible = true" width="10%" style="margin: 2px;padding: 10px 10px;margin-left: 10px;") 說明
    div(style="display: flex;height: 70px;line-height: 70px;") 
        div(style="padding-left:10px;width:35%") 行動電話
        el-input(v-model="User.userTel" style="width:45%" :disabled="true")
        div(style="width:15%")
    div(style="display: flex;height: 70px;line-height: 70px;") 
        div(style="padding-left:10px;width:35%") 地址
        // center(style="padding-top:10px") 
        el-input(v-model="User.address" style="width:70%" :disabled="false")
    
    div(slot="footer" class="dialog-footer")
      el-button(@click="outerVisible = false") 取 消
      el-button(type="primary" @click="sendDate()") 確認送出
    
</template>

<script>
import { getUserInfo, updateUserInfo } from '@/api/user'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
        User: {},
        outerVisible: false,
        innerVisible: false,
        show_go_to_line: true
    }
  },
  created() {
      this.getUser();
  },
  mounted() {
      this.add_to_home();
  },
  methods: {
      getUser(){
        let userTel = Cookies.get('phone');
        console.log(userTel) 
        getUserInfo({'userTel':userTel  }).then(res => {
            console.log(res.data) 
            let {lv, lv_is_Expired, vip_lv_is_Expired, lv_is_invalid} = res.data
            let lvName= {0:'新會員', 1:'一般會員', 2:'回頭客', 3:'熟客', 4:'熟客退回', 5: 'Vip', 6: '無效'}
            // 「無效」
            if(lv ===6 || lv_is_invalid){
                // 「無效」資格
              res.data.lvName = lvName[6]
            }
            // 「vip」
            else if(lv === 5){
              if(!vip_lv_is_Expired){
                // 「vip」資格
                res.data.lvName = lvName[lv]
              }else if(!lv_is_Expired){
                // 「熟客」資格 
                res.data.lvName = lvName[3]
              }else{
                // 「熟客退回」資格 
                res.data.lvName = lvName[4]
              }
            }
            // 「熟客」
            else if(lv === 3){
              if(!lv_is_Expired){
                // 「熟客」資格 
                res.data.lvName = lvName[3]
              }else{
                // 「熟客退回」資格 
                res.data.lvName = lvName[4]
              }
            }else{
              // 「其他lv」資格
              res.data.lvName = lvName[lv]
            } 
            this.User = res.data
            if(res.data.lineID != null &&res.data.lineID != "" ) {
              this.show_go_to_line = false
            }
        })
      },
      sendDate(){
          updateUserInfo(this.User).then(res => {
            this.outerVisible = false;
            this.getUser();
        })
      },
      add_to_home() {
        let deferredPrompt;
        const addBtn = document.querySelector('.add-button');
        window.addEventListener('beforeinstallprompt', (e) => {
          // Prevent Chrome 67 and earlier from automatically showing the prompt
          e.preventDefault();
          // Stash the event so it can be triggered later.
          deferredPrompt = e;
          // Update UI to notify the user they can add to home screen
          addBtn.addEventListener('click', (e) => {
            addToHomescreen();
            // hide our user interface that shows our A2HS button
            // addBtn.style.display = 'none';
            // Show the prompt
            deferredPrompt.prompt();
            // Wait for the user to respond to the prompt
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                  console.log('User accepted the A2HS prompt');
                } else {
                  console.log('User dismissed the A2HS prompt');
                }
                deferredPrompt = null;
              });
          });
        });
      }
  },
}
</script>
<style lang="scss">
.userInfo-icon {
  padding-left: 90vw;
}
.el-dialog{
  max-width: 650px;
}
@media (min-width: 500px) {
.userInfo {
    width: 65%;
}
.userInfo-icon {
  padding-left: 50vw;
}
}
.el-dialog{
  max-width: 500px;
}

@media (min-width: 1000px) {
.userInfo {
    width: 45%;
}
}
</style>